import { Model } from 'modules/core/lib/mobx-rest'

interface IWorkArea {
  id: number
  locationId: number
  name?: string
  location_name: string
}

class WorkArea extends Model<IWorkArea> {
  static urlRoot() {
    return '/shift_management/work_areas'
  }
}

export default WorkArea
